export function isFinishedGoodInventoryItem(item) {
  const productType = String(item?.product_type || item?.item_type || "")
    .trim()
    .toLowerCase()
    .replace(/[ -]/g, "_");
  if (productType) {
    return productType === "finished_good" || productType === "finished_goods";
  }
  return /^FG-/i.test(String(item?.item_code || item?.sku || ""));
}